module.exports = __webpack_public_path__ + "static/media/logout4x.ff1a8a39.svg";